export default "__VITE_ASSET__79f33fac__"